<h1 matDialogTitle>{{confirmMessage}}</h1>
<div fxLayoutAlign="center" mat-dialog-actions>
  <div fxFlex fxLayout="column">
    <mat-form-field appearance="outline">
      <mat-label>{{inputFieldMessage}}</mat-label>
      <input [(ngModel)]="inputFieldMessage_value" [placeholder]="inputFieldMessage" matInput>
    </mat-form-field>
    <mat-form-field appearance="outline" *ngIf="dropdown_list?.length>0">
      <mat-label>{{inputemailMessage}}</mat-label>
      <mat-select [(ngModel)]="selected_dropdown" [placeholder]="inputemailMessage">
        <mat-option [value]="option" *ngFor="let option of dropdown_list">
            {{option}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div fxLayout="row">
      <button (click)="dialogRef.close({condition:'true',message:inputFieldMessage_value,email:selected_dropdown})" class="mat-accent mr-16"
              mat-raised-button>{{addbutton}}
      </button>
      <button (click)="dialogRef.close(false)" color="warn" mat-raised-button>Cancel</button>
    </div>
  </div>

</div>

